import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Project } from '@src/app/models/project';
import { environment } from '@src/environments/environment';
import { Personproject } from '../model/personproject';
import { Personorg } from '../model/personorg';
import { Projectperson } from '@src/app/models/projectperson';
import { map } from 'rxjs/operators';




@Injectable({
  providedIn: 'root'
})
export class OrgprojectlistService {

  serviceUrl:string = environment.apiUrl+'/organization/';
  constructor(private http:HttpClient) { }

  updateProject(project:Project){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.patch<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+project.projectId,project,httpOptions)
  }
  // getOrgMembers(){
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json'
  //     })
  //   }
  //   var getListUrl = this.serviceUrl + SessionHelper.getChoosenOrg() + '/members'
  //   var result = this.http.get<Personorg[]>(getListUrl, httpOptions);
  //   //console.log(result);
  //   return result;
  // }
  // getOrgProjects(){
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json'
  //     })
  //   }
  //   return this.http.get<Project[]>(this.serviceUrl+SessionHelper.getChoosenOrg()+'/organizationproject/list',httpOptions)
  // }

  // getPersonProjects(personId:string){
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json'
  //     })
  //   }
  //   //GET	    /projectperson/list/person/{personId}/organization/{organizationId}
  //   var url = environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/projectperson/list/person/'+personId;
  //   return this.http.get<Projectperson[]>(url,httpOptions)
  // }


  getCustomers(pit:String){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/list/pit/'+pit,httpOptions)
      .pipe(map((res) => Array.isArray(res) ? res : (res?.Items || [])));
  }

  deleteProject(project:Project){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete(this.serviceUrl+SessionHelper.getChoosenOrg()+'/organizationproject/'+project.projectId,httpOptions)
  }
  joinProject(project:Personproject){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }//POST	/projectperson/{projectId}/person/{personId}	Request to join
    return this.http.post(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/projectperson/'+project.projectId+"/person/"+SessionHelper.getUserSub(),project,httpOptions);
  }
  assignToProject(project:Personproject){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }//POST	/projectperson/{projectId}/person/{personId}	Request to join
    return this.http.patch(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/projectperson/'+project.projectId+"/person/"+project.personId,project,httpOptions);
  }

}
